import type { Serializable } from './Serializable';

interface PasswordResetFormData {
  password: string;
  token: string;
}

export class PasswordResetForm implements Serializable<PasswordResetFormData> {
  password: string = '';
  confirmPassword: string = '';
  token: string = '';

  deserialize(data: PasswordResetFormData): this {
    this.password = data.password;
    this.token = data.token;
    return this;
  }

  serialize(): PasswordResetFormData {
    return {
      password: this.password,
      token: this.token,
    };
  }
}